import { createContext } from 'react';
import type {
  AfeFormInstance,
  AfeFormProviderProps,
  AfeWizardContext,
} from './types';

export interface AfeWizardContextValue extends AfeWizardContext {
  form: AfeFormInstance;
}

/** Context holding the TanStack Form instance, wizard mode, and AFE ID */
export const AfeWizardCtx = createContext<AfeWizardContextValue | null>(null);

/**
 * Provider that shares the TanStack Form instance, wizard mode, and AFE ID
 * with all step components via a single context.
 * @param {AfeFormProviderProps} props - Form instance, mode, afeId, and children
 * @return {JSX.Element} Provider wrapping children with the wizard context
 */
export const AfeFormProvider = ({
  form,
  mode,
  afeId,
  children,
}: AfeFormProviderProps) => (
  <AfeWizardCtx.Provider value={{ form, mode, afeId }}>
    {children}
  </AfeWizardCtx.Provider>
);
